import React, { useState } from "react";
import { useEffect } from "react";
import { REPORT_TYPES } from "../../../../constants/app-constant";
import { formatWidgetParams } from "../../../../utility/common-methods";
import { CustomBSDropdown } from "../../../Shared";
import { Widget } from "../Widget";

export default function AnalysisWidget({
  widgetParams,
  applyFilterTS,
  twitterFeeds = false,
  insightFeeds = 0,
  topicId,
  endRange,
  startRange,
  selectedPieEntity,
  tonality,
  twitterBreakDownPie,
  twitterBreakDownLine,
  keyMetrics,
  twitterMetricsData,
  tabData,
  widgetApiInProgress,
  setFromUserName,
  fromUserName = ""
}) {
  const [selectedFilter, setSelectedFilter] = useState(
    widgetParams.filterOption && widgetParams.filterOption[0]
  );

  const { type, filterOption = [], report_type } = widgetParams;
  const optList = Array.isArray(filterOption)
    ? filterOption.filter((el) => el.vertical.indexOf(type) !== -1)
    : [];
  const showFilters =
    optList &&
    optList.length > 1 &&
    selectedFilter.value !== REPORT_TYPES.KeywordCloudNOA &&
    selectedFilter.value !== REPORT_TYPES.Reach &&
    selectedFilter.value !== REPORT_TYPES.INFLUENCERS &&
    selectedFilter.value !== REPORT_TYPES.TopPostersWithDetail &&
    selectedFilter.value !== REPORT_TYPES.TopLanguages &&
    selectedFilter.value !== REPORT_TYPES.ThematicAnalysisEntity &&
    selectedFilter.value !== REPORT_TYPES.ThematicAnalysisTag &&
    selectedFilter.value !== REPORT_TYPES.TagBasedTagAnalysis &&
    selectedFilter.value !== REPORT_TYPES.EntityBasedTagAnalysis &&
    selectedFilter.value !== REPORT_TYPES.ShareRetweet &&
    selectedFilter.value !== REPORT_TYPES.ReplyComment &&
    selectedFilter.value !== REPORT_TYPES.Attachment && 
    selectedFilter.value !== REPORT_TYPES.Like && 
    selectedFilter.value !== REPORT_TYPES.AuthorLike && 
    selectedFilter.value !== REPORT_TYPES.TypeOfPost && 
    selectedFilter.value !== REPORT_TYPES.MemberType; 

  const renderAnalysisWidget = () => {
    if (!showFilters) return;
    return (
      <CustomBSDropdown
        config={{
          name: "report type",
          options: optList,
        }}
        selectedItem={selectedFilter}
        onSelect={setSelectedFilter}
        hideAllOption
      />
    );
  };
    return (
    <div key={`analysis-widget-${type}-${Math.random()}`} className="analysisChartWrapper">
      <Widget
        key={`analysis-widget-${type}-${Math.random()}`}
        Journalist
        isAnalysisReport
        widget={formatWidgetParams({
          ...widgetParams,
          report_type: selectedFilter && selectedFilter.value,
        })}
        applyFilterTS={applyFilterTS}
        renderAnalysisWidget={renderAnalysisWidget}
        twitterFeeds={twitterFeeds}
        insightFeeds={insightFeeds}
        topicId={topicId}
        startRange={startRange}
        endRange={endRange}
        selectedFilter={selectedPieEntity}
        tonality={tonality}
        twitterBreakDownPie={twitterBreakDownPie}
        twitterBreakDownLine={twitterBreakDownLine}
        keyMetrics={keyMetrics}
        twitterMetricsData={twitterMetricsData}
        tabData={tabData}
        widgetApiInProgress={widgetApiInProgress}
        setFromUserName={setFromUserName}
        fromUserName={fromUserName}
      />
    </div>
  );
}
